import request from '@/utils/request'
import qs from 'qs'

const proxyUrl = process.env.Communityapi;
const Community = process.env.Community;
const Jingjiribao = process.env.Jingjiribao;
const NewJingjiribao = process.env.NewJingjiribao;

// 活动首页列表数据------------------------------------


// 浏览量
export const record_save = (data) => {
  return request({
    method: 'POST',
    url: NewJingjiribao + '/visitor/record/save',
    data,
  })
}



// 活动list banner
export const getRoles = (data) => {
  return request({
    method: 'POST',
    url: Jingjiribao + '/activity/list',
    data: qs.stringify(data),

  })
}

// 活动详情-----------------------------------------------
export const avtivity_details = (data) => {
  return request({
    method: 'POST',
    url: Jingjiribao + '/activity/avtivityDetail',
    data: qs.stringify(data),

  })
}

// 作品列表
export const WorkList = (data) => {
  return request({
    method: 'GET',
    url: NewJingjiribao + '/select/work/page?activityId=' + data.activityId + '&current=' + data.current + '&size=' + data.size + '&type=' + data.type,
    data,
  })
}

// 活动公示
export const WorkPublicity = (data) => {
  return request({
    method: 'GET',
    url: NewJingjiribao + '/publicity/get/by/id?activityId=' + data.activityId,
    data,
  })
}

// 作品投票
export const playVote = (data) => {
  return request({
    method: 'GET',
    url: NewJingjiribao + '/work/vote?activityId=' + data.activityId + '&workId=' + data.workId + '&type=' + data.type,
    data,
  })
}

// 进入活动作品点击浏览
export const workClick = (data) => {
  return request({
    method: 'GET',
    url: NewJingjiribao + '/work/click?activityId=' + data.activityId + '&workId=' + data.workId + '&type=' + data.type,
    data,
  })
}

// 活动详情 判断是否关注
export const is_follow = (data) => {
  return request({
    method: 'POST',
    url: Jingjiribao + '/activity/existFollow',
    data: qs.stringify(data),
  })
}

// 活动详情关注
export const follow = (data) => {
  return request({
    method: 'POST',
    url: Jingjiribao + '/activity/activityPraise',
    data: qs.stringify(data),
  })
}


// 作品详情页-----------------------------------------------
export const WorkBy_details = (data) => {
  return request({
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    method: 'POST',
    url: NewJingjiribao + '/get/work/by/id',
    data,
  })
}

// 作品详情  相关作品
export const related_works = (data) => {
  return request({
    // headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    method: 'GET',
    url: NewJingjiribao + '/select/relate/work/page?current=' + data.current + '&size=' + data.size + '&type=' + data.type + '&workId=' + data.workId + '&authorId=' + data.authorId,
    data,
  })
}

// 作品详情  关注个人
export const insertFollow = (data) => {
  return request({
    // headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    method: 'POST',
    url: Jingjiribao + '/community/insertFollow',
    data: qs.stringify(data),
  })
}

// 作品详情  关注取消关注个人
export const deleteFollow = (data) => {
  return request({
    // headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    method: 'POST',
    url: Jingjiribao + '/community/deleteFollow',
    data: qs.stringify(data),
  })
}



// activityId,fullname,headimg,type,workId










// WEBPACK FOOTER //
// ./src/utils/api/activity.js